// extracted by mini-css-extract-plugin
module.exports = {"partners":"Partners_partners__1qdkg","partnerLogos":"Partners_partnerLogos__19eoV"};